<template>
  <vs-row vs-justify="center" id="activity-box">
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
      >
        <vs-card>
       
        <vs-table
          @search="handleSearch"
          :total="totalItems"
          max-items="10"
          search
          :data="Logs"
        >
     

          <template slot="thead">
  

                <vs-th sort-key="key">{{ $t("Kiosk.Table.Causer") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.StatusAfr") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.Action") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.Upbdated") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.Role") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.Date") }}</vs-th>
                <vs-th sort-key="key">{{ $t("Kiosk.Table.LastConnection") }}</vs-th>



            </template>


            

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
 
         
      
       

              <vs-td :data="data[indextr].causer.fname">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].causer.fname + " "+ data[indextr].causer.lname }}</h5>
                </div>
              </vs-td>


              



              <vs-td :data="data[indextr].log_name">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].log_name }}</h5>
                </div>
              </vs-td>

              
           

              
           

              
              
        
              <vs-td :data="data[indextr].description">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].description }}</h5>
                </div>
              </vs-td>


              
         

        

              <vs-td :data="data[indextr].subject_type">
  <div class="d-flex align-items-center">
    <h5 class="mb-0 font-12">{{ data[indextr].ip ? data[indextr].ip : data[indextr].subject_type.split('\\').pop() }}</h5>
  </div>
</vs-td>


              
              <vs-td :data="data[indextr].roles">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].causer.roles[0].name }}</h5>
                </div>
              </vs-td>
 
            





          
              <vs-td :data="data[indextr].created_at">
                <div class="d-flex align-items-center">
                  <span class="">{{ new Date(data[indextr].created_at).toLocaleString('en-US', {timeZone: 'UTC'}) }}</span>
                </div>
              </vs-td>


              
         
              <vs-td :data="data[indextr].created_at">
  <div class="d-flex no-block align-items-center">
    <div class>
      <span class="">
        {{
          data[indextr].created_at ?
            ((new Date().getTime() - new Date(data[indextr].created_at).getTime()) / 60000 < 60 ?
              Math.floor((new Date().getTime() - new Date(data[indextr].created_at).getTime()) / 60000).toString() + ' minutes ago' :
              (new Date().getTime() - new Date(data[indextr].created_at).getTime()) / 3600000 < 24 ?
                Math.floor((new Date().getTime() - new Date(data[indextr].created_at).getTime()) / 3600000).toString() + ' hours ago' :
                Math.floor((new Date().getTime() - new Date(data[indextr].created_at).getTime()) / (24 * 3600000)).toString() + ' day(s) ago'
            ) :
            '--'
        }}
      </span>
    </div>
  </div>
</vs-td>

            </vs-tr>
          </template>
        </vs-table>
  
          <vs-pagination
            :total="totalPages"
            @change="handleChangePage"
            v-model="currentPage"
          ></vs-pagination>
        </vs-card>
      </vs-col>
    </vs-row>
  </template>
  
  
  <script>
  import { displayService } from "../../_services";
  
  export default {
    data() {
      return {
        popupActivo4: false,
        Logs:null,
        totalItems: 0,
        maxItems:0 ,
        startdate: "2020-01-01" ,
        enddate : new Date().toISOString().slice(0, 10)


      };
    },
    computed: {
      response() {
        return this.Logs;
      },
    },
    mounted() {
      this.test();
    },
    methods: {
 
      handleChangePage() {
        this.showLoading();
        const user = JSON.parse(localStorage.getItem('user'));
        const business = user.business.id;

        displayService.getLogs({ business_id : business , current_page: this.currentPage , startdate : this.startdate , end_date:this.enddate}).then(
          function(data) {
            this.Logs = data.data.data;
          this.totalPages = data.data.last_page;
          }.bind(this))
          .finally(() => {
        this.hideLoading();
      });
      },
  
      showLoading() {
      this.$vs.loading({
        container: "#activity-box",
        scale: 0.6,
      });
    },

    hideLoading() {
      this.$vs.loading.close("#activity-box > .con-vs-loading");
    },
      
      test() {


  
      },
    },
  };
  </script>
  
  <style scoped>

  </style>
  